export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const formatDuration = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    } else {
        return `${seconds}s`;
    }
};

export const calculatePace = (duration, distance, type) => {
    if (distance === 0) return 'N/A';
    if (type === 'cycling') {
        const speed = (distance / (duration / 3600)).toFixed(2); // speed in km/h
        return `${speed} km/h`;
    } else {
        const pace = duration / 60 / distance; // pace in mins/km
        const minutes = Math.floor(pace);
        const seconds = Math.round((pace - minutes) * 60);
        return `${minutes}m ${seconds}s / km`;
    }
};
